import Grid from "@mui/material/Grid2";

export function CarouselItem({ imgUrl, imgTitle }) {
  return (
    <Grid className="carousel-card">
      <img width={150} src={imgUrl} alt={imgTitle} loading="lazy"></img>
    </Grid>
  );
}
